module.exports = __webpack_public_path__ + "static/media/1.a7d938d0.jpg";